module.exports = __webpack_public_path__ + "static/media/import.2c5fa0ab.svg";